<template>
    <div class="slider">
        <carousel :autoplay="5000" :transition="1000" :items-to-show="1" :wrapAround="true">
            <slide v-for="slide in slides" :key="slide">
                <div class="slider__item" :style="handleSlide(slide)">
                    <a v-if="slide.image" :href="slide.url">
                        <img :src="'https://api.library.loxone.com/files/global/slider/' + slide.image">
                    </a>
                    <template v-else>
                        <p class="title--pre">{{slide.pre_title}}</p>
                        <h1 class="title" v-html="slide.title"></h1>
                        <p class="text">{{slide.text}}</p>
                    </template>
                </div>
            </slide>
            <template #addons>
                <pagination />
            </template>
        </carousel>
    </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination} from 'vue3-carousel';

export default {
    name: 'App',
    components: {
        Carousel,
        Slide,
        Pagination
    },
    data() {
        return {
            slides: [
                /*{
                    pre_title:  'Unlimited Possibilities',
                    title:      "The New Loxone Config<br/>Resource Library",
                    text:       'The right place for every Use Case',
                    bg_color:   '#FF0000',
                }*/
                {
                    image: 'miele.jpg',
                    url:    'https://library.loxone.com/detail/miele@home-358/overview'
                },
                {
                    image: 'powerwall.jpg',
                    url:    'https://library.loxone.com/detail/tesla-powerwall-233/overview'
                },
                {
                    image: 'home-connect.jpg',
                    url:    'https://library.loxone.com/detail/home-connect-63/overview'
                },
                {
                    image: 'oekofen.jpg',
                    url:    'https://library.loxone.com/detail/oekofen-pelletronic-73/overview'
                },
                {
                    image: 'oekofen2.jpg',
                    url:    'https://library.loxone.com/detail/oekofen-pelletronic-73/overview'
                },
            ],
        }
    },
    methods: {
        handleSlide(slide) {
            var data = '';
            if(slide.bg_color) {
                data += 'background-color: ' + slide.bg_color + ';';
            }
            return data;
        }
    },
};
</script>

<style lang="scss">
    .carousel__pagination-item button{
        width: 12px;
        font-size: 0px;
        height: 12px;
        border-radius: 50%;
        background-color: rgba(61,61,61,0.3);

        &.carousel__pagination-button--active{
            background-color: #3D3D3D;
        }
    }
</style>

<style lang="scss" scoped>
    .title--pre{
        margin: 0;
        padding: 0;
        color: #FFFFFF;
        font-size: 23px;
        line-height: 30px;
    }
    .title{
        margin: 15px 0 25px 0;
        padding: 0;
        color: #FFFFFF;
        font-size: 50px;
        line-height: 55px;
    }
    .text{
        margin: 0;
        padding: 0;
        color: #FFFFFF;
        font-size: 16px;
        line-height: 20px;
    }
    img{
        max-width: 100%;
        height: auto;
    }
    .slider__item{
        padding: 0;
        width: 100%;
        cursor: pointer;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
    }
</style>